import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewCapabilityCardComponent } from './view-capability-card.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';


@NgModule({
  declarations: [
    ViewCapabilityCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule
  ],
  exports: [
    ViewCapabilityCardComponent
  ],
})
export class ViewCapabilityCardModule { }
